import { UseFormReturn } from 'react-hook-form';
import { SurveyFormData } from '@/utils/validation';

interface OpenEndedSectionProps {
  form: UseFormReturn<SurveyFormData>;
}

const OpenEndedSection = ({ form }: OpenEndedSectionProps) => {
  const {
    register,
    formState: { errors },
  } = form;

  return (
    <section aria-labelledby="section-c-heading" className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
      <div className="flex items-center mb-6">
        <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center mr-3">
          <svg className="w-6 h-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
        </div>
        <h2
          id="section-c-heading"
          className="text-2xl font-bold text-gray-900"
        >
          Section C: Open-Ended Feedback
        </h2>
      </div>
      <p className="text-sm text-gray-600 mb-6 -mt-2 ml-[52px]">
        Share your thoughts and suggestions (required)
      </p>
      <div className="space-y-6">
        <div>
          <label
            htmlFor="likesMost"
            className="block text-sm font-semibold text-gray-700 mb-2"
          >
            What do you like most about our products/services?
          </label>
          <textarea
            id="likesMost"
            rows={4}
            {...register('open.likesMost')}
            className="block w-full rounded-lg border border-gray-300 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors sm:text-sm py-3 px-4 resize-y text-gray-900 dark:text-gray-100"
            placeholder="Tell us what you appreciate most..."
            aria-invalid={errors.open?.likesMost ? 'true' : 'false'}
            aria-describedby={
              errors.open?.likesMost ? 'likesMost-error' : undefined
            }
          />
          {errors.open?.likesMost && (
            <p
              id="likesMost-error"
              className="mt-1 text-sm text-red-600"
              role="alert"
            >
              {errors.open.likesMost.message}
            </p>
          )}
        </div>

        <div>
          <label
            htmlFor="areasForImprovement"
            className="block text-sm font-semibold text-gray-700 mb-2"
          >
            What areas need improvement?
          </label>
          <textarea
            id="areasForImprovement"
            rows={4}
            {...register('open.areasForImprovement')}
            className="block w-full rounded-lg border border-gray-300 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors sm:text-sm py-3 px-4 resize-y text-gray-900 dark:text-gray-100"
            placeholder="Help us improve by sharing areas for enhancement..."
            aria-invalid={
              errors.open?.areasForImprovement ? 'true' : 'false'
            }
            aria-describedby={
              errors.open?.areasForImprovement
                ? 'areasForImprovement-error'
                : undefined
            }
          />
          {errors.open?.areasForImprovement && (
            <p
              id="areasForImprovement-error"
              className="mt-1 text-sm text-red-600"
              role="alert"
            >
              {errors.open.areasForImprovement.message}
            </p>
          )}
        </div>

        <div>
          <label
            htmlFor="wouldDoBusinessAgain"
            className="block text-sm font-semibold text-gray-700 mb-2"
          >
            Would you do business with us again? Why or why not?
          </label>
          <textarea
            id="wouldDoBusinessAgain"
            rows={4}
            {...register('open.wouldDoBusinessAgain')}
            className="block w-full rounded-lg border border-gray-300 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors sm:text-sm py-3 px-4 resize-y text-gray-900 dark:text-gray-100"
            placeholder="Share your thoughts on future business opportunities..."
            aria-invalid={
              errors.open?.wouldDoBusinessAgain ? 'true' : 'false'
            }
            aria-describedby={
              errors.open?.wouldDoBusinessAgain
                ? 'wouldDoBusinessAgain-error'
                : undefined
            }
          />
          {errors.open?.wouldDoBusinessAgain && (
            <p
              id="wouldDoBusinessAgain-error"
              className="mt-1 text-sm text-red-600"
              role="alert"
            >
              {errors.open.wouldDoBusinessAgain.message}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default OpenEndedSection;

